import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'animate.css';

// Redirect zxing-wasm WASM fetch to our self-hosted copy (avoids CDN + CSP issues)
import { setZXingModuleOverrides } from 'vue-qrcode-reader';
setZXingModuleOverrides({ locateFile: () => '/zxing_reader.wasm' });

// ----- Pinia (Vue 3 state management) -----
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { useAuthStore } from './stores/auth'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
// ------------------------------------------

// ----- API & Notification Services -----
import ApiService, { initializeApiService } from './services/api'
import NotificationService from './services/notification'
// ---------------------------------------

// ----- Bootstrap CSS -----
import 'bootstrap/dist/css/bootstrap.css'
// -------------------------

// ----- Flag Icons -----
import 'flag-icons/css/flag-icons.min.css'
// ----------------------

// ----- Glass UI Design System -----
import './assets/styles/global.css'
import GlassUI from './components/ui'
// ----------------------------------

// Create Vue 3 app
const app = createApp(App)

// Use plugins
app.use(pinia)
app.use(router)
app.use(NotificationService)
app.use(GlassUI)

// Global properties (replacing Vue.prototype)
app.config.globalProperties.$api = ApiService

// Create a $store compatibility layer for Vuex-style access
// This allows existing components using $store.getters.* to continue working
const storeCompatibility = {
  get getters() {
    const authStore = useAuthStore()
    return {
      token: authStore.token,
      role: authStore.role,
      is_pro: authStore.is_pro,
      id: authStore.id,
      cartCount: authStore.cartCount
    }
  },
  get state() {
    const authStore = useAuthStore()
    return {
      token: authStore.token,
      role: authStore.role,
      is_pro: authStore.is_pro,
      id: authStore.id,
      cartCount: authStore.cartCount
    }
  },
  commit(mutation, payload) {
    const authStore = useAuthStore()
    switch (mutation) {
      case 'loginUser':
        authStore.login(payload.token, payload.refresh_token)
        break
      case 'setUserInfo':
        authStore.setUserInfo(payload)
        break
      case 'setVeto':
        authStore.setVeto()
        break
      case 'logoutUser':
        authStore.logout()
        break
      default:
        console.warn(`Unknown mutation: ${mutation}`)
    }
  }
}

app.config.globalProperties.$store = storeCompatibility

// Initialize API service with auth store
const authStore = useAuthStore()
initializeApiService(
  () => authStore.token,
  () => authStore.logout(),
  () => authStore.refreshAccessToken()
)

// Mount app
app.mount('#app')

// ── Web Vitals RUM (Real User Monitoring) ──
import { initWebVitals } from './webVitals'
initWebVitals(ApiService)
